import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// 1. Import the libs you need
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { DevComponent } from './dev/dev.component';
import { GuideComponent } from './guide/guide.component';
import { PreviewItemComponent } from './preview-item/preview-item.component';
import {HttpClientModule} from '@angular/common/http';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CaseDialogComponent } from './case-dialog/case-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';

// 2. Add your credentials from step 1
const firebaseConfig = {
  apiKey: "AIzaSyAfskfoUjpQoYHPAGWDzbCbYTKF8_WGcxE",
  authDomain: "dimondigitall.firebaseapp.com",
  databaseURL: "https://dimondigital-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "dimondigital",
  storageBucket: "dimondigital.appspot.com",
  messagingSenderId: "635576059976",
  appId: "1:635576059976:web:50088a3f43be4c3e9e307d"
};

@NgModule({
  declarations: [
    AppComponent,
    DevComponent,
    GuideComponent,
    PreviewItemComponent,
    CaseDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MatDialogModule,
    // 3. Initialize
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule, // firestore
    AngularFireAuthModule, // auth
    AngularFireStorageModule, BrowserAnimationsModule // storage
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
